// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { RoomInformationsComponent } from './room-informations.component';

@NgModule({
    declarations: [
        RoomInformationsComponent,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        RoomInformationsComponent,
    ],
})
export class RoomInformationsModule {}